var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"},{name:"observe-visibility",rawName:"v-observe-visibility",value:({
    callback: _vm.visibilityChanged,
    once: true,
  }),expression:"{\n    callback: visibilityChanged,\n    once: true,\n  }"}],class:['WhatsAvatar img-fluid rounded-circle', { WithError: _vm.error }],attrs:{"src":_vm.avatarUrl || _vm.defaultUserSvg,"alt":"Avatar","rel":"preload"},on:{"error":_vm.loadError}})
}
var staticRenderFns = []

export { render, staticRenderFns }